import { type FC, type ReactNode } from 'react'
import { useTheme } from 'styled-components'

import { BodyTypeCarousel } from '@/components/brp/BodyTypeCarousel'
import { CategoryTypeCarousel } from '@/components/brp/CategoryTypeCarousel'
import { MaintainProtectCarousel } from '@/components/brp/MaintainProtectCarousel'
import { TopCarsBanner } from '@/components/brp/top-cars-banner'
import { Flex } from '@/ui/atoms/flex'

/**
 * Vertical landing section for BRP
 * It should only be rendered if:
 * - When no filters have been selected
 * - On BRP (Search without a keyword)
 * - When category is Cars & Trucks (ID: 174)
 */
type BRPTopCarsTrucksProps = {
  children: ReactNode
}

export const BRPTopCarsTrucks: FC<BRPTopCarsTrucksProps> = ({ children }) => {
  const { spacing } = useTheme()

  return (
    <Flex flexDirection="column" gap={spacing.husky}>
      <TopCarsBanner>{children}</TopCarsBanner>
      <BodyTypeCarousel />
      <CategoryTypeCarousel />
      <MaintainProtectCarousel />
    </Flex>
  )
}
